<template>
    <gofix-card title="Rectification" class="h-100" v-if="Item && (Item.status == 'Contractor Supervisor Acknowledged' || Item.status == 'Pending Acknowledgement' || Item.status == 'Completed')">
        <template slot="gofixCard:right_header">
            <gofix-button v-if="$checkRole(this.$accessModule.safety_inspection_checklist, 'update') && (Item && Item.status == 'Contractor Supervisor Acknowledged')" label=" " @click="storageItem" noBorder>
                <template slot="gofix:button:beforeLabel">
                    <img v-if="action_taken && action_taken.id" width="20" src="img/iconPencil.png" alt="" />
                    <svg v-else width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                        <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                        <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                    </svg>
                    
                </template>
            </gofix-button>
        </template>
        <b-row>
            <b-col md="9" class="mb-15">
                <gofix-text-field classLabel="min-width-auto" label="Action Taken" oneline>
                    <span v-html="action_taken && action_taken.description ? action_taken.description.replaceAll('\n', '<br>') : ''"></span>
                </gofix-text-field>
            </b-col>
            <b-col md="5" class="photosThumb photosThumb-safety mt-0">
                <gofix-text-field classLabel="min-width-auto" label="photos" oneline>
                    <template v-if="action_taken && action_taken.attachments">
                        <viewer-image :images="action_taken.attachments" classViewer='d-flex align-items-center'>
                            <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                <ul class="list-thumb">
                                    <template v-for="(item, key) in images">
                                        <li v-if="key < limitImage" :class="{'d-none': images.length > limitImage && key >= ((limitImage - 1) ? (limitImage - 1) : 1)}" v-bind:key="key">
                                            <img :alt="item.image_file_name" :key="item.url.original" v-auth-image="item.url.original"  src="img/loading.gif">
                                        </li>
                                    </template>
                                </ul>
                                <template v-if="images.length > limitImage">
                                    <div class="attachmentsColumn cursor-pointer pl-0">
                                        <div class="item-content bg-transparent pd-0">
                                            <img class="image-viewer" v-auth-image="images[images.length-1].url.original" src="img/loading.gif">
                                            <span class="checklist-photo-custom" v-if="images.length > limitImage">+{{ images.length - limitImage }}</span>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </viewer-image>
                    </template>
                </gofix-text-field>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Action Taken" hide-footer :centered="true" v-model="open">
            <b-form class="pb-10">
                <gofix-form-input-textarea label="Action Taken" :rows="5" v-model="service_report.description"></gofix-form-input-textarea>
                <b-form-group label="photos" class="photosThumb clear-both">
                    <ul class="list-thumb">
                        <li v-for="(item,key) in service_report.attachments" v-bind:key="key">
                            <img v-auth-image="item.url.thumb" src="img/loading.gif" alt />
                            <span class="delete" @click="deleteimgServiceReport(item)">
                                <img src="img/close.png" alt />
                            </span>
                        </li>
                    </ul>
                    <div class="upload-btn-wrapper">
                        <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="imgServiceReport" :plain="true" :multiple="true"></b-form-file>
                        <gofix-button class="m-3" label="add photo" outline></gofix-button>
                    </div>
                </b-form-group>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SAVE" @click="saveItem" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>

<script>
    import { mapGetters } from 'vuex';
    const ViewerImage = () => import('../../plugins/ViewerImage.vue')
    import moment from 'moment';
    export default {
        name: 'service-report-wf-and-at',
        components: {
            ViewerImage,
        },
        props: {
            safety_work_finding_id: {
                type: Number
            },
            action_taken: {
                type: Object,
                default: {}
            },
        },
        data() {
            return{
                isAction: false,
                limitImage: 2,
                imgServiceReport: null,
                imgServiceReportAction: {
                    photos: [],
                    delete: [],
                },
                service_report_del_ids: [],
                service_report: {},
                timer: {
                    edit: null,
                },
                open: false,
                api: {
                    work_finding: 'order-work-finding',
                    action_taken: 'order-action-taken',
                }
            }
        },
        mounted() {
            this.$nextTick(function () {
                window.addEventListener('resize', this.handleResize);
            })
        },
        computed: {
            ...mapGetters({
                Item: 'SafetyAppController/safetyJob',
            }),
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        created() {
            this.handleResize();
        },
        watch: {
            imgServiceReport(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };

                        this.imgServiceReportAction.photos.push(file);
                        this.service_report.attachments.push(data);
                    });
                }
            }
        },
        methods: {
            handleResize() {
                this.limitImage = 2
                if (window.innerWidth < 1920) {
                    this.limitImage = 1
                }
            },
            storageItem() {
                this.isAction = false;

                this.service_report_del_ids = [];
                this.imgServiceReportAction.photos = [];
          
                if(this.action_taken && this.action_taken.id) {
                    this.service_report = {
                        id: this.action_taken.id,
                        safety_work_finding_id: this.safety_work_finding_id,
                        description: this.action_taken.description ? this.action_taken.description : '',
                        attachments: this.action_taken.attachments ? JSON.parse(JSON.stringify(this.action_taken.attachments)) : [],
                        status: this.action_taken.status
                    };
                } else {
                    this.service_report = {
                        safety_work_finding_id: this.safety_work_finding_id,
                        description: null,
                        attachments: [],
                        status: 'Rectified'
                    }
                }
                this.open = true;
            },
            saveItem() {
                if (this.timer.edit) {
                    clearTimeout(this.timer.edit);
                    this.timer.edit = null;
                }
                this.timer.edit = setTimeout(async () => {
                    if (this.isAction) return;

                    this.isAction = true;

                    if(this.service_report_del_ids.length > 0) {
                        await this.$store.dispatch("SafetyAppController/deleteAttachments", { ids : this.service_report_del_ids } )
                        .then(result => {
                            this.service_report_del_ids = [];
                        })
                    }

                    await this.$store
                        .dispatch("SafetyAppController/saveActionTaken", {
                            data:   this.service_report,
                            photos: this.imgServiceReportAction.photos
                        })
                        .then(async (result) => {

                            this.imgServiceReportAction = {
                                photos: [],
                                delete: [],
                            };

                            this.open    = false;
                            this.$alertNotification(this.$notificationV2(this.service_report.id ? "editing" : "adding", "safe_inspection_checklist_action_taken"));
                            this.$emit("reloadData")
                        })
                        .catch(error => {
                            this.isAction = false;
                            console.log(error);
                        });
                }, 100)
            },
            deleteimgServiceReport(img) {
                if (img.moment) {
                    this.service_report.attachments = this.service_report.attachments.filter(
                        (item) => item.moment != img.moment
                    );
                    this.imgServiceReportAction.photos = this.imgServiceReportAction.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.service_report_del_ids.push(img.id);
                    this.service_report.attachments = this.service_report.attachments.filter(
                        (item) => item.id != img.id
                    );
                }
            }
        }
    }
</script>